/**
 * 无人车站点管理（一期）
 */
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import dayjs from 'dayjs'
import { SiteStatus, YN } from '@/config/enums'
import { commonOptions } from '@/config/options'
import { addEditDialog, logDialog } from './_dialogs'
import type { PageContext } from '@zto/zpage-runtime'


export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/site/page',
        apiParams:{
          leader: YN.NO
        },
        method: 'POST',
        // responseTransform: (res: any) => {
        //   if (res && Array.isArray(res.list)) {
        //     return {
        //       data: res.list || [],
        //       total: res.total || 0
        //     }
        //   }
        //   return res
        // }
      },
      add: {
        label: '新建站点',
        api: '/sys/admin/site/create',
        method: 'POST',
        dialog: addEditDialog(false),
        successMessage: '站点已创建'
      },
      edit: {
        label: '编辑',
        api: '/sys/admin/site/update',
        method: 'POST',
        payload: {
          siteCode: '${data.row.siteCode}'
        },
        dialog: addEditDialog(true),
        successMessage: '站点已更新'
      },
      disable: {
        label: '禁用',
        api: '/sys/admin/site/changeStatus',
        method: 'POST',
        payload: {
          siteCode: '${data.row.siteCode}',
          status: SiteStatus.DISABLED
        },
        message: '禁用后不可发起新的配送任务，确认禁用该站点吗？',
        successMessage: '站点已禁用'
      },
      enable: {
        label: '启用',
        api: '/sys/admin/site/changeStatus',
        method: 'POST',
        payload: {
          siteCode: '${data.row.siteCode}',
          status: SiteStatus.ENABLED
        },
        message: '确认启用该站点吗？',
        successMessage: '站点已启用'
      },
      log: {
        label: '日志',
        dialog: logDialog()
      },
      // bind: {
      //   label: '绑定兔喜',
      //   dialog: logDialog()
      // },
      unbind: {
        api: 'sys/admin/site/unbindStore',
        payload: { siteCode: '${data.row.siteCode}' },
        label: '解绑兔喜',
        message: '确定解绑站点${data.row.siteName}与${data.row.depotName}(编号：${data.row.depotCode})的关联？解绑后物流轨迹相关能力将受影响，需重新绑定后方可恢复。'
      },
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 90,
      items: [
        // { type: 'input', prop: 'siteCode', label: '站点编号', span: 6 },
        { type: 'input', prop: 'siteName', label: '站点名称', span: 6 },
        { type: 'select', prop: 'status', label: '状态', options: commonOptions.siteStatus, span: 6 },
        {
          type: 'fuzzy-select',
          prop: 'communityCode',
          labelProp: 'communityName',
          label: '所属小区',
          optionValueProp: 'communityCode',
          optionLabelProp: 'communityName',
          triggerFocus: true,
          remote: true,
          keywordProp: 'communityName',
          api:'/sys/admin/api/region/community/pageList',
          span: 6
        }
      ]
    },
    toolbar: {
      noExport: true,
      items: [{ action: 'add' }]
    },
    table: {
      operation: {
        width: 180,
        items: [
          { action: 'edit' },
          { action: 'disable', visibleOn: `this.data.row.status === '${SiteStatus.ENABLED}'` },
          { action: 'enable', visibleOn: `this.data.row.status === '${SiteStatus.DISABLED}'` },
          { action: 'log' },
          { action: 'bind', label: '',
            labelWidth: 0,
            visibleOn: `!this.data.row.depotCode`,
            cmpt: ({ data }: PageContext) => {
              return { type: 'CBindShopAction', baseInfoRowData: data.row, title: '绑定兔喜', align: 'left' }
            } },
          { action: 'unbind', visibleOn: `this.data.row.depotCode` },
        ]
      },
      innerAttrs: {
        rowKey: 'siteCode',
        operationPosition: 'left',
        noIndex: false,
        // pageSize: 10,
        // pageSizes: [5, 10, 15, 20],
      },
      columns: [
        { label: '站点编号', prop: 'siteCode', minWidth: 180 },
        { label: '站点名称', prop: 'siteName', minWidth: 140 },
        {
          label: '状态',
          prop: 'status',
          minWidth: 90,
          // prop: 'type',
          formatter: { name: 'enumStr', options: 'siteStatus' },
        },
        {
          label: '关联小区',
          prop: 'communities',
          minWidth: 220,
          formatter: (row: any) => {
            const list = row?.siteCommunityList || []
            if (!Array.isArray(list) || !list.length) return '--'
            const names = list.map((it: any) => it?.communityName).filter(Boolean)
            return names.join('、')
          }
        },
        {
          label: '地址',
          prop: 'addressDetail',
          minWidth: 220,
          formatter: (row: any) => {
            return [row?.province, row?.city, row?.district, row?.addressDetail].filter(Boolean).join('-')
          }
        },
        {
          label: '负责人',
          prop: 'leaderName',
          minWidth: 180,
          formatter: (row: any) => {
            return [row?.leaderName, row?.leaderPhone].filter(Boolean).join(' ')
          }
        },
        {
          label: '兔喜门店',
          prop: 'shopName',
          minWidth: 180,
          // formatter: (row: any) => {
          //   return [row?.leaderName, row?.leaderPhone].filter(Boolean).join(' ')
          // },
          body: ({ data }: PageContext) => {
            const rowData = data.row
            return {
              type: 'html',
              html: `
              <div style="display: flex; flex-direction: column">
              <div>门店名称：${rowData.depotName || '--'}</div>
              <div>编号：${rowData.depotCode || '--'}</div>
</div>
        `
            }
          }
        },
        {
          label: '站点人员',
          prop: 'siteUserCount',
          minWidth: 120,
          formatter: (row: any) => {
            const total = row?.siteUserCount
            // if (verifiedCount != null && total != null) return `${verifiedCount}/${total}`
            return total ?? '--'
          }
        },
        { label: '整车数', prop: 'siteVehicleDeviceCount', minWidth: 100 },
        {
          label: '更新时间',
          prop: 'gmtModified',
          minWidth: 170,
          formatter: (row: any) => (row?.gmtModified ? dayjs(row.gmtModified).format('YYYY-MM-DD HH:mm:ss') : '--')
        }
      ]
    }
  }
}
